module.exports = __webpack_public_path__ + "img/4d60f9cbae9cf3e1c9f65ee3aee8d248.png";